import http from '../http';

// All calls go through the rich http client (auth header, prod payload
// encryption, concurrency gate). FormData uploads are passed through untouched
// by http.js (it skips encryption for FormData), so the image upload works here.
export const blogsApi = {
  // ── Public ────────────────────────────────────────────────────────────
  listPublic() {
    return http.get('/api/blogs').then((r) => r.data.posts);
  },
  getBySlug(slug) {
    return http.get(`/api/blogs/${slug}`).then((r) => r.data.post);
  },

  // ── Super-admin ───────────────────────────────────────────────────────
  listAdmin() {
    return http.get('/api/blogs/admin/all').then((r) => r.data.posts);
  },
  getOne(id) {
    return http.get(`/api/blogs/admin/${id}`).then((r) => r.data.post);
  },
  create(body) {
    return http.post('/api/blogs', body).then((r) => r.data.post);
  },
  update(id, body) {
    return http.put(`/api/blogs/${id}`, body).then((r) => r.data.post);
  },
  remove(id) {
    return http.delete(`/api/blogs/${id}`).then((r) => r.data);
  },
  reorder(orderedIds) {
    return http.patch('/api/blogs/reorder', { orderedIds }).then((r) => r.data);
  },
  uploadImage(file) {
    const form = new FormData();
    form.append('image', file);
    return http
      .post('/api/blogs/upload-image', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data.url);
  },
};

export default blogsApi;
